import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-panel-header',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './panel-header.component.html',
})
export class PanelHeaderComponent {}
